/*
 * Genovare V2 legal pages. Builds the "On this page" list from the page's own section headings, numbers and links
 * them, and highlights the section in view on desktop. On the Shopify privacy policy page it also lays the policy
 * out (contents on the left, text on the right) without changing the policy text.
 */
(function () {
  'use strict';

  function slug(text, used) {
    var base = text.toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
    var id = base;
    var n = 2;
    while (used[id] || document.getElementById(id)) {
      id = base + '-' + n++;
    }
    used[id] = true;
    return id;
  }

  function init() {
    var policy = document.querySelector('.shopify-policy__container');
    var parts = document.querySelector('[data-gv-legal-parts]');
    var body;
    if (policy) {
      body = policy.querySelector('.rte') || policy.querySelector('.shopify-policy__body');
      if (!body) return;
      policy.classList.add('gv', 'gv-lg-policy');
      var wrap = policy.querySelector('.shopify-policy__body');
      if (parts) {
        var nav = parts.querySelector('[data-gv-toc-nav]');
        var short = parts.querySelector('[data-gv-short]');
        if (nav) policy.insertBefore(nav, wrap);
        if (short) {
          var firstHeading = body.querySelector('h2, h3');
          if (firstHeading) body.insertBefore(short, firstHeading);
          else body.insertBefore(short, body.firstChild);
        }
        parts.remove();
      }
      // The hero already says when the policy was last updated.
      var firstP = body.querySelector('p');
      if (firstP && /^\s*last updated/i.test(firstP.textContent)) firstP.classList.add('gv-lg-hidden');
    } else {
      body = document.querySelector('[data-gv-legal-body]');
    }
    if (!body) return;
    body.classList.add('gv-lg-body');

    // Headings stay in order under the page's h1: a policy that starts at h3 is moved up one level (text unchanged).
    if (!body.querySelector('h2') && body.querySelector('h3')) {
      Array.prototype.slice.call(body.querySelectorAll('h3, h4, h5')).forEach(function (h) {
        var up = document.createElement('h' + (Number(h.tagName.charAt(1)) - 1));
        Array.prototype.slice.call(h.attributes).forEach(function (a) {
          up.setAttribute(a.name, a.value);
        });
        up.innerHTML = h.innerHTML;
        h.parentNode.replaceChild(up, h);
      });
    }
    var level = body.querySelector('h2') ? 'h2' : 'h3';
    var heads = Array.prototype.slice.call(body.querySelectorAll(level));
    var nav = document.querySelector('[data-gv-toc-nav]');
    var list = document.querySelector('[data-gv-toc]');
    if (!heads.length || !nav || !list) return;

    var used = {};
    var links = [];
    heads.forEach(function (h) {
      h.classList.add('gv-lg-h');
      var host = h.closest('.gv-lg-sec');
      var anchor;
      if (host && host.id) anchor = host.id;
      else {
        if (!h.id) h.id = slug(h.textContent, used);
        anchor = h.id;
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'gv-lg-toc__link';
      a.href = '#' + anchor;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      links.push({ head: h, link: a });
    });
    nav.hidden = false;

    if (!('IntersectionObserver' in window)) return;
    var current = null;
    function mark(entry) {
      if (current === entry.link) return;
      if (current) {
        current.classList.remove('is-current');
        current.removeAttribute('aria-current');
      }
      current = entry.link;
      current.classList.add('is-current');
      current.setAttribute('aria-current', 'location');
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (l) {
            if (l.head === e.target) mark(l);
          });
        });
      },
      { rootMargin: '-15% 0px -75% 0px', threshold: 0 }
    );
    heads.forEach(function (h) {
      io.observe(h);
    });
    if (links[0]) mark(links[0]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
